import moment from 'moment'

moment.locale('zh-cn');

const merge = function(oparams,cparams){
	if(cparams!=undefined){
		for(var name in cparams){
			if(typeof cparams[name]=='object'&&!Array.isArray(cparams[name])){
				if(oparams[name]==null)
					oparams[name]={};
				oparams[name]=merge(oparams[name],cparams[name]);
			}
			else{
				oparams[name]=cparams[name];
			}
		}
	}
	return oparams;
}

const install = function(Vue, opts = {}) {
	Vue.prototype.$g = (obj,name,returnNull)=>{
		var objs=obj;
		if(!Array.isArray(obj)){
			objs=[obj];
		}
		
		var texts=[];
		for(var i=0;i<objs.length;i++){
			var names=name.split('.');
			var output=objs[i];
			for(var j=0;j<names.length;j++){
				if(output==null)
					break;
				output=output[names[j]];
			}
			if(returnNull&&output==null){
				return null;
			}
			if(output==null){
				output='';
			}
			texts.push(output);
		}
		if(texts.length==1){
			return texts[0];
		}
		return texts.map(m=>m.toString()).join(',');
	};
	
	Vue.prototype.$moment = (d)=>{
		return moment(d);
	};
	
	Vue.prototype.$merge = (o,c)=>{
		return merge(o,c);
	}
	
	Vue.prototype.$now = ()=>{
		var now=new Date();
		var year=now.getFullYear();
		var month=now.getMonth()>8?now.getMonth()+1:'0'+(now.getMonth()+1);
		var day=now.getDate()>9?now.getDate():'0'+now.getDate();
		var hour=now.getHours()>9?now.getHours():'0'+now.getHours();
		var minute=now.getMinutes()>9?now.getMinutes():'0'+now.getMinutes();
		var second=now.getSeconds()>9?now.getSeconds():'0'+now.getSeconds();
		return year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second;
	};
}

export default {
	install:install,
	merge
}